export const environment = {
  production: true,
  apiUrl: '/api',
  chatHubUrl: '/chatHub',
  testUser: {
    token: {},
    email: '',
  },
};
